const formConstants = {
	FETCH_REQUEST: 'FETCH_REQUEST',
	FETCH_SUCCESS: 'FETCH_SUCCESS',
	FETCH_FAILURE: 'FETCH_FAILURE',
	UPDATE_LIST: 'UPDATE_LIST',
	UPDATE_FIELDS: 'UPDATE_FIELDS',
};

export default formConstants;
